import { InitialConfig } from './typings/initial';

export default window.INITIAL_CONFIG as InitialConfig;
